import {
  ISupervisorApprovedPayload,
  ISupervisorApprovedResponse,
  ISupervisorResponse,
} from '../../../interfaces/supervisor.interface'
import { GET, POST } from '../config'

export interface ISupervisorAPI {
  fetch: (payload: string) => Promise<ISupervisorResponse>
  decide: (
    payload: ISupervisorApprovedPayload,
    params: string,
  ) => Promise<ISupervisorApprovedResponse>
}

export default {
  fetch: (payload: string, params?: any): Promise<ISupervisorResponse> => {
    return GET(`/api/v1/application/${payload}/`, { params }).then((res) => res.data)
  },

  decide: (
    payload: ISupervisorApprovedPayload,
    params: string,
  ): Promise<ISupervisorApprovedResponse> => {
    return POST(`/api/v1/application/${params}/decide/`, payload).then((res) => res.data)
  },
}
